import EventBus, { EventName } from '../../../../Shared/Assets/event-bus';
import {empty} from '../../../../Shared/Assets/utils';

export default class EnquiryTracking {
    constructor() {
        this._handleEnquirySentSuccess = this._handleEnquirySentSuccess.bind(this);
        this._initConversionTracking = this._initConversionTracking.bind(this);
        this.eventBus = new EventBus();
        this.shouldFireBmwConversionTracking = false;
    }

    init() {
        this.eventBus.handle(EventName.EnquirySentSuccess, this._handleEnquirySentSuccess);
        this._initConversionTracking();
    }

    _initConversionTracking() {
        let $this = this;
        $("[data-conversion-tracking-tag]").each(function () {
            if (this.getAttribute("data-conversion-tracking-tag") === "BmwDemoEnquiry" 
                    && $this.shouldFireBmwConversionTracking == false) {
                $this.shouldFireBmwConversionTracking = true;
                console.debug("BmwConversionTracking is registered and ready to fire");
            }
        });
    }

    _fireBmwConversionTracking() {
        if (typeof window.BmwDemoEnquiryTrackingLoaded !== 'undefined') {
            return;
        }
        window.BmwDemoEnquiryTrackingLoaded = true;
        var oImg=document.createElement("img");
        oImg.setAttribute('src', '//mm.carsales.com.au/carsales/count/actid=207/advid=9&rnd=' + Math.random());
        oImg.setAttribute('alt', '');
        oImg.setAttribute('height', '1px');
        oImg.setAttribute('width', '1px');
        document.body.appendChild(oImg);

        console.debug("BmwConversionTracking is fired");
    }

    _handleEnquirySentSuccess(data) {
        this._fireBingClickTracking();
        if (this.shouldFireBmwConversionTracking) {
            this._fireBmwConversionTracking();
        }
    }

    _fireBingClickTracking() {
        window.uetq = window.uetq || [];
        window.uetq.push({ 'ec': 'button', 'ea': 'Click', 'el': 'Send Enquiry' });
    }
}